var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"resource":"dns_zones","statusModule":"dnszone","nameProps":{edit: false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }